import { namespace } from '../constants';

export const Placeholder = ({ children }: { children: React.ReactNode }) => (
  <span className={`${namespace}__placeholder`}>{children}</span>
);
